export const LUMERATEC_SET_USER = 'LUMERATEC_SET_USER';
export const LUMERATEC_RESET = 'LUMERATEC_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
